import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal',
  standalone: true,
})
export class UtcToLocalPipe implements PipeTransform {
  transform(value: string | Date, isOnlyDate: boolean = false): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      value = value.toISOString();
    }

    const cleanedValue = value.endsWith('Z') ? value.slice(0, -1) : value;
    const dateOnly = cleanedValue.length <= 10;

    let utcDate: Date;
    if (!dateOnly && !isOnlyDate) {
      utcDate = new Date(`${cleanedValue}`);
    } else {
      const clDate = new Date(cleanedValue);
      utcDate = new Date(clDate.getFullYear(), clDate.getMonth(), clDate.getDate());
      return utcDate;
    }

    if (isNaN(utcDate.getTime())) {
      return null;
    }

    const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
    return localDate;
  }
}
